import { useMemo } from 'react';

export default function useDefinitions() {
  return useMemo(() => ({
    entityName: 'Blacklist',
    entityNamePlural: 'Blacklist',
    entityNameModule: 'settings',
    filters: { active: true },
  }), [])
}
